import { render } from "./TdsReport.vue?vue&type=template&id=7c10b337&scoped=true"
import script from "./TdsReport.vue?vue&type=script&lang=js"
export * from "./TdsReport.vue?vue&type=script&lang=js"

import "./TdsReport.vue?vue&type=style&index=0&id=7c10b337&scoped=true&lang=css"

import exportComponent from "/private/var/www/html/goldenaces-club/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c10b337"]])

export default __exports__